// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"485db1e1","579":"827b70e8","787":"15262bf7"}[chunkId] + ".chunk.js";
};